import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import imagineLogo from "./img/logo.png";

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();

  useEffect(() => {
    changeDefaultLocale('es');
  }, [changeDefaultLocale]);

  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: "",
    });

    api
      .userPassLogin(
        {
          username,
          password,
        },
        parameters
      )
      .then((response) => {
        setOnLogin(false);
        window.location =
          parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false);
        setError({ open: true, message: message });
      });
  };

  return (
    <div className="imagineintegrators-container">
      <img src={imagineLogo} alt="Imagine Conecta" className="imagineintegratorsLogo" />
      <CSSTransition
        in={showForm}
        timeout={300}
        classNames="imagineintegrators-formshow"
        nodeRef={nodeRef}
        unmountOnExit
      >
        <div className="imagineintegrators-form-wrapper" ref={nodeRef}>
          <Form onSubmit={(event) => onSubmit(event)} className="imagineintegrators-form">
            <p className="text-header">{translate("Header")}</p>
            <input
              className="imagineintegratorsInput usernameInput input"
              disabled={onLogin}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
              onChange={(e) => setUsername(e.target.value)}
              placeholder={translate("PlaceholderUserName")}
            />
            <input
              className="imagineintegratorsInput passwordInput input"
              required={true}
              disabled={onLogin}
              tabIndex={2}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
              placeholder={translate("PlaceholderPassword")}
              onChange={(e) => setPassword(e.target.value)}
            />

            <div className="rememberMe">
              <label>
                <input type="checkbox" />
                {translate("RemindMe")}
              </label>
            </div>

            {!onLogin ? (
              <div className="imagineintegrators-submit-container">
                <button
                  tabIndex={3}
                  type="submit"
                  id="submit"
                  className="imagineintegratorsSubmit"
                >
                  {translate("ButtonEnter")}
                </button>
                <div className="not-registered">
                  <a href="#" className="registerLink">{translate("NotRegistered")}</a>
                </div>
              </div>

            ) : (
              <Progress animated value={100} className="imagineintegrators-progress" />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    </div>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '1rem' } });
